import { httpClient } from '../httpClient/httpClient';
import { UserType } from './userApi';
import { baseApiUrl } from '../httpClient/constants';

export interface CustomerUser {
  id: number;
  userName: string;
  userId: number;
  email: string;
  userType: UserType | null;
  customUserType: string | null;
  branchId: number | null;
  branchIdentifier?: string;
  isMain: boolean;
  lastLogin: string;
  userArchived: string | null;
}

interface AddCustomerUserRequest {
  userId: number;
  branchId?: number;
  type: UserType | null;
}

export interface AddExternalBrandUser {
  customerId: number;
  userId: number;
}

export interface SearchExternalUser {
  customerId: number;
  searchTerm: string;
  includeArchived: boolean;
  sortBy: string;
  sortDesc: boolean;
}

export interface SetCustomTypeRequest {
  customType: string;
}

export const customerUsersApi = {
  getUsers: (customerId: number) =>
    httpClient.get<CustomerUser[]>(`customer-users/customer/${customerId}/all`),
  getExternalUsers: (params: SearchExternalUser) =>
    httpClient.get<CustomerUser[]>(
      `customer-users/customer/${params.customerId}/all-external`,
      { params },
    ),
  getInternalUsersByPaId: (productApprovalId: number) =>
    httpClient.get<CustomerUser[]>(
      `customer-users/product-approval/${productApprovalId}/all-internal`,
    ),
  getAvailableExternalUsers: (customerId: number) =>
    httpClient.get<CustomerUser[]>(
      `customer-users/customer/${customerId}/available-external`,
    ),
  getAllCustomTypes: () =>
    httpClient.get<string[]>(`customer-users/all-custom-types`),
  setCustomType: (id: number, request: SetCustomTypeRequest) =>
    httpClient.put(`customer-users/${id}/set-custom-type`, { data: request }),
  removeUser: (id: number) => httpClient.delete(`customer-users/${id}`),
  setMain: (id: number) => httpClient.put(`customer-users/${id}/set-main`),
  removeUserFromAll: (customerId: number, userId: number) =>
    httpClient.delete(`customer-users/customer/${customerId}/${userId}`),
  addUser: (customerId: number, data: AddCustomerUserRequest) =>
    httpClient.post<number>(`customer-users/customer/${customerId}`, { data }),
  addExternalBrandUser: (data: AddExternalBrandUser) =>
    httpClient.post<number>(`customer-users/customer/external-user`, { data }),
  downloadTeamPdf: (customerId: number) =>
    `${baseApiUrl}/customer-users/customer/${customerId}/download/team`,
};
